// modules/prescriptionDefinition/impl/service/repository/prescriptionDefinition.dataservice.ts
import { Injectable } from "@angular/core";
import { DefaultDataServiceConfig, Logger } from "@ngrx/data";
import { HttpClient } from "@angular/common/http";
import { AbstractDataServiceV2 } from "src/app/modules/core/service/v2/dataservice/abstractDataServiceV2";
import { CustomizeHttpUrlGenerator } from "src/app/store/core/url/customizeHttpUrlGenerator";
import { PrescriptionDefinitionModel } from "../../../api/entity/prescriptionDefinition.model";
import { PrescriptionDefinitionConverter } from "../../../api/entity/converter/prescriptionDefinition.converter";

@Injectable({
    providedIn: 'root'
})
export class PrescriptionDefinitionDataService extends AbstractDataServiceV2<PrescriptionDefinitionModel, PrescriptionDefinitionConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: PrescriptionDefinitionConverter
    ) {
        super('PrescriptionDefinition', http, httpUrlGenerator, logger, config, converter);
    }
}